import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@/components/IconComponent';
import { useValidDate } from '@/modules/promo/hooks/useValidDateFromQuery';
import { ScTermsAndConditions } from './styled';

interface TermsProps {
  translation: string;
  grayBg?: boolean;
  validDate?: string;
  isTitleBtnOpacity?: boolean;
  isReverseArrow?: boolean;
}

export const TermsAndConditions: FC<TermsProps> = ({
  translation,
  grayBg,
  validDate,
  isReverseArrow,
  isTitleBtnOpacity,
}) => {
  const { t } = useTranslation(translation);

  const [isOpen, setIsOpen] = useState(false);

  const validDateFromQuery = useValidDate(validDate);

  return (
    <ScTermsAndConditions
      grayBg={grayBg}
      isOpen={isOpen}
      isReverseArrow={isReverseArrow}
      isTitleBtnOpacity={isTitleBtnOpacity}
    >
      <div className="terms__title" onClick={() => setIsOpen((prev) => !prev)}>
        <span>{t('common:button.termsAndConditions')}</span>
        <div className="arrow-wrapper">
          <IconComponent name="whiteArrowRight" size="18px" />
        </div>
      </div>
      <div className="terms">
        <div className="terms-content">
          <ol>
            {Object.values(
              t('termsContent', {
                returnObjects: true,
                date: validDateFromQuery,
              })
            ).map((rule, index) => (
              <li key={index}>{rule as string}</li>
            ))}
          </ol>
        </div>
      </div>
    </ScTermsAndConditions>
  );
};
